export function startClock() {
  return { type: 'INIT_CLOCK' }
}

export function stopClock() {
  return { type: 'STOP_CLOCK' }
}
